// time delay helper is a function that delays the execution of a function for a given amount of time
// minus the time it took to execute the function.
export default function (start, delay = 300) {
  return new Promise((resolve) => {
    const resolvedDelay = delay - (Date.now() - start) || 0
    setTimeout(() => {
      resolve()
    } , resolvedDelay)
  })
}